/* eslint-disable no-restricted-syntax */
import { Divider, Group, Text } from '@mantine/core';
import { Icon, IconCheck } from '@tabler/icons-react';
import { ReactNode } from 'react';

interface PlanSelectItemProps extends React.ComponentPropsWithoutRef<'div'> {
  label: string;
  extras: {
    cotacao: string;
    primary: boolean;
    hidePrimaryHeader?: boolean;
    itens: {
      icone: Icon;
      fornecedor: string;
    }[];
  }[];
}

interface QuotationSelectItemProps extends React.ComponentPropsWithoutRef<'div'> {
  label: string;
  extras: {
    icone: Icon;
    fornecedor: string;
  }[];
}

const buildSelectPlanItem = (props: PlanSelectItemProps) => {
  const { label, extras } = props;
  const nodes: ReactNode[] = [];

  for (const extra of extras) {
    if (!extra.hidePrimaryHeader) {
      nodes.push(
        <Group gap={1}>
          <div>{`Cotação ${extra.cotacao}`}</div>
          {extra.primary && (
            <div>
              <IconCheck color="green" size={15} />
            </div>
          )}
        </Group>
      );
    }

    for (const item of extra.itens) {
      nodes.push(
        <Group gap="xs" wrap="nowrap">
          <item.icone size={15} />
          <div>{item.fornecedor}</div>
        </Group>
      );
    }
    nodes.push(<Divider my="xs" />);
  }
  nodes.pop();

  return (
    <Group wrap="nowrap">
      <div>
        <Text size="sm">{label}</Text>
        {nodes.length > 0 && (
          <Text size="xs" opacity={0.65}>
            {nodes}
          </Text>
        )}
      </div>
    </Group>
  );
};

const buildSelectQuotationItem = (props: QuotationSelectItemProps) => {
  const { label, extras } = props;
  const nodes: ReactNode[] = [];

  for (const extra of extras) {
    nodes.push(
      <Group gap="xs" wrap="nowrap">
        <extra.icone size={15} />
        <div>{extra.fornecedor}</div>
      </Group>
    );
  }

  return (
    <Group wrap="nowrap">
      <div>
        <Text size="sm">{label}</Text>
        {nodes.length > 0 && (
          <Text size="xs" opacity={0.65}>
            {nodes}
          </Text>
        )}
      </div>
    </Group>
  );
};

export { buildSelectPlanItem, buildSelectQuotationItem };
